$(function () {
    $('.navbar-toggle').click(function(){
        $('.account').toggleClass('navMobile-open');
        $('body').toggleClass('not-scroll');
    })
});
